// Alerts - /admin/alerts (0064). The saved passes that wait on the admin,
// one row per open alert, newest alert first: the alert's line (a link to the
// run page, where the admin resumes or closes the pass), the product, when
// the pass stopped and when it closes. The founder app shows a saved pass as
// running, so this page is where the admin finds it.
//
// Backend: GET /api/v1/admin/alerts (admin_alerts.go), shared with the
// header's count and the browser notifier (useAdminAlerts).
import { Link } from "react-router-dom";
import { useUser } from "../auth/useUser";
import { Header } from "../components/Header";
import { Table, THead, TBody, TR, TH, TD } from "../components/Table";
import { useAdminAlerts } from "../hooks/useAdminAlerts";
import {
  ALERTS_HEADING,
  NO_ALERTS,
  alertDate,
  alertProduct,
  alertTitle,
} from "../lib/adminAlerts";

export function Alerts() {
  const { data: me } = useUser();
  const q = useAdminAlerts(!!me?.is_admin);

  if (!me) return null;

  return (
    <div className="min-h-screen flex flex-col">
      <Header user={me} />
      <main className="flex-1 max-w-6xl mx-auto w-full px-4 sm:px-8 py-10">
        <h1 className="text-display font-medium text-ink-50 tracking-tightest mb-6">
          {ALERTS_HEADING}
        </h1>

        {q.isLoading && <p className="text-sm text-ink-400">loading…</p>}
        {q.error && (
          <p className="text-sm text-rose-300">
            Failed: {(q.error as Error).message}
          </p>
        )}
        {q.data && q.data.length === 0 && (
          <p className="text-sm text-ink-400">{NO_ALERTS}</p>
        )}

        {q.data && q.data.length > 0 && (
          <Table>
            <THead>
              <TH>alert</TH>
              <TH>product</TH>
              <TH>stopped</TH>
              <TH>closes</TH>
            </THead>
            <TBody>
              {q.data.map((a) => (
                <TR key={a.run_id}>
                  <TD>
                    <Link
                      to={`/users/${a.user_id}/products/${a.product_id}/runs/${a.run_id}`}
                      className="text-orange-200 hover:text-accent"
                    >
                      {alertTitle(a)}
                    </Link>
                  </TD>
                  <TD className="text-ink-200">{alertProduct(a)}</TD>
                  <TD className="font-mono text-[11px] text-ink-300">
                    {alertDate(a.stopped_at)}
                  </TD>
                  <TD className="font-mono text-[11px] text-ink-300">
                    {alertDate(a.closes_at)}
                  </TD>
                </TR>
              ))}
            </TBody>
          </Table>
        )}
      </main>
    </div>
  );
}
